"use client";
import React from "react";
import {
  BgImg2Wrap,
  ContentContainer,
  Layout,
  Stack,
  AccreContainer,
  AccreOverImg,
  PrimaryBtn,
  AccreOverImgBig,
  SecondaryBtn,
} from ".";
import data from "../../assets/common.json";
import dynamic from "next/dynamic";
import { useDictionary } from "../../context/dictionaryProvider";
import { useDisclosure } from "@nextui-org/react";
import { useParams, useRouter } from "next/navigation";
import { trackEvent } from "../../lib/engageXClient";
const EnquireModal = dynamic(() => import("../modal/EnquireModal"));

const RightEnrollWrapper = ({
  children,
  shape,
  btnText,
  btnStyle,
  bgColorValue,
  showBtn = true,
  isEnquire,
  course,
  ratingClass,
  enquireCss,
  redirectUrl,
  section = "modal",
}) => {
  const { isOpen, onOpenChange } = useDisclosure();
  const dict = useDictionary();
  const router = useRouter();
  const params = useParams()
  return (
    <>
      <Layout
        className={`${
          ratingClass ? ratingClass : "mt-20"
        } accreditations mb-[8.5rem] mx-0`}
      >
        {!shape ? <BgImg2Wrap /> : shape}
        <ContentContainer>
          <Stack>
            <AccreContainer
              className={`px-10 md:px-20 pt-20 pb-28 z-0 ${
                bgColorValue ? bgColorValue : ""
              }`}
              style={{ width: "100%" }}
            >
              {isEnquire ? (
                <>
                  <AccreOverImgBig />
                  <SecondaryBtn
                    className={`${
                      enquireCss ? enquireCss : "right-0"
                    } !bg-[#316BCB] viewAllBtn`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (section === "pay_later") {
                        trackEvent("installment_interest", { provider: "pay_later" });
                      }
                      trackEvent("enquire_click", { section });
                      onOpenChange();
                    }}
                  >
                    {dict?.enquireNow}
                  </SecondaryBtn>
                </>
              ) : (
                showBtn && (
                  <>
                    <AccreOverImg className={``} accreImg />
                    <PrimaryBtn
                      className={`${params.lang === "ar" ? "!-right-2 !left-auto": ""} viewAllBtn`}
                      style={btnStyle}
                      onClick={() => redirectUrl && router.push(redirectUrl)}
                    >
                      {btnText || data.viewAll}
                    </PrimaryBtn>
                  </>
                )
              )}

              {children}
            </AccreContainer>
          </Stack>
        </ContentContainer>
        {isOpen && (
          <EnquireModal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            course={course}
            section={section}
          />
        )}
      </Layout>
    </>
  );
};

export default RightEnrollWrapper;
